module.exports = __webpack_public_path__ + "static/img/050501.6e093894.png";